import styled from 'styled-components';

export const LoadingStateRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  height: 230px;
  justify-content: center;
`;

export const Label = styled.span`
  color: var(--text-soft);
`;
